module.exports = __webpack_public_path__ + "static/media/watchlater-icon.2ca2fc8f.svg";